import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { StylesProvider, useModeTokens, text, border } from '@rexlabs/styling';
import Tag from '../core';
import { getCompactTokens } from '../modes/compact';
var baseTokens = {
  tag: _objectSpread(_objectSpread(_objectSpread({}, text.tokens({
    target: 'tag.status.average'
  })), border.tokens({
    target: 'tag.status.average',
    all: {
      color: 'warning.idle.contrast'
    }
  })), {}, {
    background: {
      color: function color(_ref) {
        var token = _ref.token;
        return token('tag.status.average.background.color', token('color.warning.idle.contrast'));
      }
    },
    hover: _objectSpread(_objectSpread(_objectSpread({}, text.tokens({
      target: 'tag.status.average.hover'
    })), border.tokens({
      target: 'tag.status.average.hover',
      all: {
        color: 'warning.hover.contrast'
      }
    })), {}, {
      background: {
        color: function color(_ref2) {
          var token = _ref2.token;
          return token('tag.status.average.hover.background.color', token('color.warning.hover.contrast'));
        }
      }
    })
  })
};
var modeTokens = [{
  mode: 'compact',
  tokens: getCompactTokens('tag.status.average.compact')
}];

function StatusAverageTag(_ref3, ref) {
  var _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? 'Average' : _ref3$children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  var tokens = useModeTokens(baseTokens, modeTokens);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, props, {
    ref: ref
  }), children));
}

export default /*#__PURE__*/forwardRef(StatusAverageTag);